export interface CookieAttributes {
  /** Lifetime in days. Omit for a session cookie. */
  expires?: number;
  path?: string;
}

export function getCookie(name: string): string | undefined {
  if (typeof document === 'undefined') {
    return undefined;
  }
  const prefix = `${encodeURIComponent(name)}=`;
  for (const part of document.cookie.split('; ')) {
    if (part.startsWith(prefix)) {
      return decodeURIComponent(part.slice(prefix.length));
    }
  }
  return undefined;
}

export function setCookie(
  name: string,
  value: string,
  attributes: CookieAttributes = {}
): void {
  if (typeof document === 'undefined') {
    return;
  }
  const parts = [
    `${encodeURIComponent(name)}=${encodeURIComponent(value)}`,
    `path=${attributes.path ?? '/'}`,
  ];
  if (attributes.expires != null) {
    const expiresAt = new Date(
      Date.now() + attributes.expires * 24 * 60 * 60 * 1000
    );
    parts.push(`expires=${expiresAt.toUTCString()}`);
  }
  document.cookie = parts.join('; ');
}
